import { render } from "./SheetPriceComponent.vue?vue&type=template&id=59d2cc66&scoped=true"
import script from "./SheetPriceComponent.vue?vue&type=script&lang=js"
export * from "./SheetPriceComponent.vue?vue&type=script&lang=js"

import "./SheetPriceComponent.vue?vue&type=style&index=0&id=59d2cc66&scoped=true&lang=css"

import exportComponent from "D:\\Cotizador Frontend\\dyc_cotizador_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59d2cc66"]])

export default __exports__